import {
  IconButton,
  Menu,
  MenuItem,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core"
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline"
import MoreVertIcon from "@material-ui/icons/MoreVert"
import PersonIcon from "@material-ui/icons/Person"
import PropTypes from "prop-types"
import React, { useContext, useState } from "react"
import { useMutation } from "react-query"
import { deleteAnalyticsUser } from "~/actions/users"
import HoverText from "~/components/Common/HoverText"
import PaperListRow from "~/components/Common/PaperListRow"
import PermissionsWrapper from "~/components/Common/PermissionsWrapper"
import AppContext from "~/contexts/App"
import Box from "../../Common/Box"
import useStyles from "./styles"

const AnalyticsCard = ({ analyticsUser, i }) => {
  const classes = useStyles()
  const theme = useTheme()
  const smScreen = useMediaQuery(theme.breakpoints.down("sm"))
  const [anchorEl, setAnchorEl] = useState(null)

  const deleteAnalyticsUserMutaiton = useMutation(deleteAnalyticsUser)
  const { authUser, openDialog } = useContext(AppContext)

  // //open dialog to delete admin
  const openDeleteConfirmation = () => {
    let data = {
      title: "Delete Analytics User",
      subtitle: "",
      type: "analytics_user",
      delete: deleteAnalyticsUserMutaiton,
      id: analyticsUser.id,
      confirmWord: "delete",
    }
    openDialog("confirmationTypingDialog", data)
    handleCloseMenu()
  }

  const editUser = () => {
    let data = {
      name: analyticsUser?.name,
      email: analyticsUser?.email,
      id: analyticsUser?.id,
      clients: analyticsUser?.clients,
    }
    openDialog("createAnalyticsUserDialog", data)
    handleCloseMenu()
  }

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleCloseMenu = () => {
    setAnchorEl(null)
  }
  //fjsa
  return (
    <Box marginBottom="16px">
      <PaperListRow
        key={i}
        componentWidth="100%"
        componentHeight={smScreen ? "90px" : "64px"}
      >
        {smScreen ? (
          <Box display="flex" alignItems="center" className={classes.nameText}>
            <span className={classes.labelSpan}>Name:&nbsp; </span>
            <HoverText
              data={analyticsUser?.name}
              size={100}
              variant={"subtitle1"}
            />
          </Box>
        ) : (
          <Box display="flex" alignItems="center" className={classes.nameText}>
            <HoverText
              data={analyticsUser?.name}
              size={100}
              variant={"subtitle1"}
            />
          </Box>
        )}
        {smScreen ? (
          <Box className={classes.emailText}>
            <span className={classes.labelSpan}>Email:&nbsp;</span>
            <Typography variant={"subtitle1"}>
              {analyticsUser?.email}
            </Typography>
          </Box>
        ) : (
          <Box className={classes.emailText}>
            <HoverText
              data={analyticsUser?.email}
              size={100}
              variant={"subtitle1"}
            />
          </Box>
        )}
        {smScreen ? (
          <Box className={classes.clientText}>
            <Typography variant="subtitle1">
              <span className={classes.labelSpan}>Client Count: </span>{" "}
              {analyticsUser?.clients.length}
            </Typography>
          </Box>
        ) : (
          <Box className={classes.clientText}>
            <Typography variant="subtitle1">
              {analyticsUser?.clients.length}
            </Typography>
          </Box>
        )}
        {/* <Box className={classes.clientText}>
          <Typography variant="subtitle1">
            {analyticsUser?.clients.length}
          </Typography>
        </Box> */}
        <Box>
          <PermissionsWrapper permissionGroup="super">
            <IconButton onClick={handleOpenMenu}>
              <MoreVertIcon color="primary" />
            </IconButton>
          </PermissionsWrapper>
          <Menu
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleCloseMenu}
          >
            <MenuItem onClick={editUser}>
              <PersonIcon
                fontSize="inherit"
                style={{ fontSize: "16px", marginRight: "4px" }}
              />
              <Typography>Edit </Typography>
            </MenuItem>
            <MenuItem onClick={openDeleteConfirmation}>
              <DeleteOutlineIcon
                fontSize="inherit"
                color="inherit"
                style={{
                  fontSize: "16px",
                  marginRight: "4px",
                  color: "#FF5E69",
                }}
              />
              <Typography color="inherit" style={{ color: "#FF5E69" }}>
                Remove
              </Typography>
            </MenuItem>
          </Menu>
        </Box>
      </PaperListRow>
    </Box>
  )
}

AnalyticsCard.propTypes = {
  analyticsUser: PropTypes.object,
  i: PropTypes.string,
}

export default AnalyticsCard
